module.exports = __webpack_public_path__ + "img/mockup.30322d80.png";